import {
  Placeholder,
  Report,
  ReportAttributes,
  FormAttributes,
} from './report.interface';
import {
  formPlaceholders,
  sxmReports,
  telematicsReports,
  tciReports,
} from './report.details';
import { UntypedFormGroup, Validators } from '@angular/forms';

export class ReportModel {
  /**
   *@var error to store error status
   **/
  public error: any;
  /**
   *@var startDateKey to name the header of the api for the selected date
   **/
  public startDateKey = 'StartDatetime';
  /**
   *@var endDateKey to name the header of the api for the selected date
   **/
  public endDateKey = 'EndDatetime';
  /**
   *@var _placeholders  to store placeholders in the form's label
   **/
  private _placeholders: Placeholder;
  /**
   *@var _reports to store report data
   **/
  private _reports: Array<Report>;
  /**
   *@var _formAttriutes to store form values in the model
   **/
  private _formAttriutes: FormAttributes;
  constructor() {
    this._placeholders = formPlaceholders;
    this._reports = [sxmReports, tciReports, telematicsReports];
  }
  /**
   * formConfigs returns A collection of form controls. The key is the name under which it is registered in the form.
   * value here is default values and set of validators
   **/
  get formConfigs(): { [key: string]: Array<any> } {
    return {
      reportOf: [null, [Validators.required]],
      reportOn: [null, [Validators.required]],
      startDate: [null, [Validators.nullValidator]],
      endDate: [null, [Validators.nullValidator]],
    };
  }
  /**
   * placeholder returns the placeholder
   **/
  get placeholders(): Placeholder {
    return this._placeholders;
  }
  /**
   * findReportOf returns filtered report names that are belong to selected report of
   **/
  findReportOf(report_on_name): Array<ReportAttributes> {
    const report = this._reports.find((_report) => _report.reportOn === report_on_name);
    return report ? report.reportOf : [];
  }
  /**
   * title returns if the title of the report page
   **/
  get title(): string {
    return 'report-main.labels.title';
  }

  /**
   * setFormAttributes set to form attributes from formgroup
   **/
  setFormAttributes(report_attributes: UntypedFormGroup) {
    this._formAttriutes = Object.create({
      reportName: report_attributes.value.reportOn,
      reports: report_attributes.value.reportOf,
      startDateKey: this.startDateKey,
      endDateKey: this.endDateKey,
      startDateValue: report_attributes.value.startDate,
      endDateValue: report_attributes.value.endDate,
    } as FormAttributes);
  }
  /**
   * formAttributes get call when form attributes are required
   **/
  get formAttributes(): FormAttributes {
    return this._formAttriutes;
  }
  /**
   * clearFormAttributes call that reuired to clear form attributes as empty
   **/
  clearFormAttributes() {
    this._formAttriutes = Object.create({} as FormAttributes);
  }

  /**
   * getRouteParams Returns the params for vin list by vin
   **/
  get reports(): Array<Report> {
    return this._reports;
  }
}
